import { CRUDEntity } from "../abstracts/CRUDEntity";

export class OrganisationEmail extends CRUDEntity {
    constructor(id=null){
        super();
        this.entityClass = 'email-campaign';
        this.urlRoot = '/email-department';
        this.sectionRootUrl = '/email-department';
        this.id = id;
    }
}